<template>
  <div class="main">
    <div class="kupon-gosok-container type3">
      <div class="kupon-gosok-instructions">
        <span id="title">SELAMAT,</span><br>
        <span id="title-2">KAMU DAPAT KUPON JAJAN!</span><br>
        <span id="title-3">GOSOK SEKARANG!</span>
      </div>
      <div class="kupon-gosok-content kupon-c" :class="{ counting: !isFinishedScratch }" fetchpriority="high">
        <div class=" scratch-container">
          <!-- Loading animation that shows while scratch card initializes -->
          <div id="scratchLoading" class="scratch-loading">
            <div class="scratch-loading-spinner"></div>
            <div class="scratch-loading-text">Memuat...</div>
          </div>
          <!-- Adding inline style to hide the code initially before JavaScript loads -->
          <div class="scratch-code" id="scratchCode" v-if="!isRedirect" style="visibility: hidden;">{{ code }}</div>
          <div class="redirect-text" v-if="isRedirect">Menghubungkan Anda ke Telkomsel…</div>
          <canvas id="scratchCanvas" class="scratch-canvas"></canvas>
        </div>
        <div class="countdown-container">
          <span class="countdown-text">Hangus dalam </span>
          <span class="countdown-timer" id="countdownTimer">05:00</span>
        </div>
      </div>
      <div class="redemption-text" id="redemptionText" v-if="isFinishedScratch">
        <p>Catat & Jajanin PULSA + KUOTA</p>
        <div class="button-popup-confirmation d-flex align-items-center mt-1">
          <button type="button" class="redemption-btn-red btn-block" id="redemptionWebOptIn"
            @click="submitCode(code)">SALIN &amp; KLAIM DI SINI
            <span aria-hidden="true">&rsaquo;</span></button>
        </div>
      </div>
      <div class="kjtnc" @click="openTnC()" v-if="isFinishedScratch">Syarat & Ketentuan</div>
    </div>
  </div>
</template>

<script>
import { global, scratchC } from "../utils";
import { event } from 'vue-gtag'
import config from '../utils/config';
import { Api } from "../services";
import { useRoute } from 'vue-router'
import { useHead } from '@vueuse/head'

export default {
  name: 'KuponJajan',
  setup() {
    const images = [
      'img/ticket.webp',
    ];

    const css = [
      'css/scratch.css',
    ];

    const preloadLinks = images.map(src => ({
      rel: 'preload',
      as: 'image',
      href: `${process.env.BASE_URL}${src}`,
      fetchpriority: 'high'
    }))

    const cssLink = css.map(src => ({
      rel: 'stylesheet',
      href: `${process.env.BASE_URL}${src}`,
    }))

    useHead({
      link: [
        ...preloadLinks,
        ...cssLink
      ]
    })
  },
  data() {
    return {
      code: "??????",
      isFinishedScratch: false,
      isFirstScratch: true,
      isRedirect: false,
      route: "",
    }
  },
  mounted() {
    scratchC.useScratchCardC(this);
    this.code = global.generateCodeKuponJajan();
    this.ready();
    const route = useRoute()
    if (route.path === '/kj') {
      this.route = config.idw_url;
    } else if (route.path === '/kjw') {
      this.route = config.kjw_url;
    } else if (route.path === '/id4') {
      this.route = config.id4_url;
    } else if (route.path === '/spw') {
      this.route = config.spw_url;
    }
  },
  methods: {
    sendGtag(type) {
      if (type == 0) {
        event('Gosok Kupon - KJ', {})
      } else if (type == 1) {
        event('Success - Call WebOptIn - KJ', {})
      } else if (type == 2) {
        event('Failed - Send Kode to API - KJ', {})
      } else if (type == 3) {
        event('Open T&C - KJ', {})
      }
    },
    openTnC() {
      this.sendGtag(3);
      window.open('https://bit.ly/idwap', '_blank').focus();
    },
    async submitCode(code) {
      var self = this;
      self.isRedirect = true;

      try {
        await navigator.clipboard.writeText(code);
      } catch (err) {
        console.error("Copy failed:", err);
      }

      Api.submitCode(code)
        .then((data) => {
          if (data.data.success == 1) {
            this.sendGtag(1)
          } else {
            this.sendGtag(2)
          }
          global.portalRedirect(self.route, code, 1500)
        })
        .catch(function (error) {
          console.log(error)
        });
    },
    ready() {
      window.countdownTimer = null;
      window.timeLeft = config.timer;
      const timerElement = document.getElementById('countdownTimer');

      window.countdownTimer = setInterval(function () {
        const minutes = Math.floor(window.timeLeft / 60);
        const seconds = window.timeLeft % 60;

        // Format time as MM:SS
        const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        timerElement.textContent = formattedTime;

        // Change color when time is running out (less than 1 minute)
        if (window.timeLeft <= 60) {
          timerElement.style.color = '#fcc621';
          timerElement.style.fontWeight = 'bold';
        }

        // When time reaches 0
        if (window.timeLeft <= 0) {
          clearInterval(window.countdownTimer);
          timerElement.textContent = 'Sudah Hangus';
          timerElement.style.color = '#fcc621';
          timerElement.style.fontWeight = 'bold';

          // Also update the countdown text
          const countdownTextElement = document.querySelector('.countdown-text');
          if (countdownTextElement) {
            countdownTextElement.textContent = '';
          }
          return;
        }

        window.timeLeft--;
      }, 1000);
    },
  }
}

</script>
